import { Heading } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const LocationsView = () => {
  return (
    <>
      <Heading as={"h2"} p={3}>
        E-commerce - Warehouses
      </Heading>

      <Outlet />
    </>
  );
};

export default LocationsView;
